module.exports = __webpack_public_path__ + "img/image_correction_after.77f459fb.png";